
import { combineReducers } from 'redux';

import {
    GET_OPSUB_OLD_ACTION_TYPE,
    GET_OPSUB_NEW_ACTION_TYPE,
} from '../../sagas/analyze2opsub';

import opsub from './opsub';
import analyze from './analyze';
import reducer from './reducer';

export function getAnalyze(state) {
    return state.analyze;
}

export function getDefault(state) {
    return state.default;
}

export function getOpsubNew(state) {
    return state.opsubNew;
}

export function getOpsubOld(state) {
    return state.opsubOld;
}

export default combineReducers({
    analyze: analyze(),
    default: reducer,
    opsubOld: opsub(GET_OPSUB_OLD_ACTION_TYPE),
    opsubNew: opsub(GET_OPSUB_NEW_ACTION_TYPE)
});
